import { HelpCircle, Loader2, Send } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

export const AskQuestionPanel = ({
  question,
  setQuestion,
  onAsk,
  loading,
  aiResponse,
}) => (
  <div className="bg-card rounded-2xl border border-primary/10 p-6 mb-8">
    <h3 className="text-lg font-semibold text-primary mb-3 flex items-center gap-2">
      <HelpCircle className="h-5 w-5" />
      Ask a Question About Your Matches
    </h3>
    <div className="flex gap-3">
      <Input
        placeholder="e.g., Which country has the best healthcare for retirees?"
        value={question}
        onChange={(e) => setQuestion(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && onAsk()}
        className="flex-1"
        data-testid="question-input"
      />
      <Button
        onClick={onAsk}
        disabled={loading || !question.trim()}
        className="btn-animated bg-primary hover:bg-primary/90 gap-2"
        data-testid="submit-question-btn"
      >
        {loading ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <Send className="h-4 w-4" />
        )}
        Ask
      </Button>
    </div>
    {aiResponse && (
      <div className="mt-4 p-4 bg-accent/10 rounded-lg border border-accent/20">
        <p className="text-foreground/80 whitespace-pre-line">{aiResponse}</p>
      </div>
    )}
  </div>
);

export default AskQuestionPanel;
